import React from 'react';
import '../styles/lantern-loader.css';

/** Quiet child waiting state. The lantern remains present when motion is reduced. */
export default function LanternLoader({ label = 'Waiting for your quests; the list is not known yet.' }) {
  return <div className="lantern-loader" data-component="LanternLoader" role="status" aria-live="polite" aria-busy="true">
    <svg data-lantern-loader-art="true" viewBox="0 0 48 64" width="48" height="64" fill="none" aria-hidden="true" focusable="false">
      <g stroke="currentColor" strokeWidth="2">
        <path d="M18 14V9a6 6 0 0 1 12 0v5M12 18h24l-3 35H15zM10 57h28M19 20l1 30M29 20l-1 30" />
      </g>
      <path className="lantern-loader-light" d="M24 29c7 8 7 14 0 17-7-3-7-9 0-17Z" fill="currentColor" />
    </svg>
    <p>{label}</p>
  </div>;
}
